import gql from 'graphql-tag';

const GET_ORDER_COMMENTS = gql`
  # Write your query or mutation here
  
  query getCommentsbyOrderId($orderId: String) {
    getCommentsbyOrderId(orderId: $orderId) {
      count
      page
      pageSize
      results {
        ... on Comment {
          idOrder
          comment
          user
          phone
          contactType
          createdAt
          dataSource
        }
      }
    }
  }
`;

export default GET_ORDER_COMMENTS;
